import { useSuspenseQuery } from '@tanstack/react-query';
import { API } from 'api';

import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';
import { apiName, apiBasePath } from 'assets/constants';
import { ActionPlanItem } from 'types/ActionPlan';

export async function getActionPlanData(kitId: string) {
  const response = await API.get(
    apiName,
    `${apiBasePath}/actionplan/v5/${kitId}`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.ACTION_PLAN,
        domain: DOMAINS.ACTION_PLAN,
        importance: IMPORTANCE.CRITICAL,
      },
      context: {
        kitId,
      },
    },
  );

  return response?.result;
}
export const getActionPlanItemsQuery = (kitId: string | null | undefined) => ({
  queryKey: [apiName, 'actionPlanData', 'v5', kitId],
  queryFn: () => (kitId ? getActionPlanData(kitId) : []),
});

const useActionPlanData = ({ kitId }: { kitId?: string | null }) => {
  const actionPlanDataQuery = useSuspenseQuery<ActionPlanItem[] | null>(
    getActionPlanItemsQuery(kitId),
  );
  return actionPlanDataQuery;
};

export default useActionPlanData;
